export default "/images/vendor/flag-icon-css/flags/1x1/by.svg?0bc23418cf7a453885cf44eb911ca371";